<template>
  <div style="position:relative; overflow: hidden;">

    <div class="rasgado rasgado-top"></div>

    <!-- Flores decorativas en las orillas -->
    <img 
      src="@/assets/ssss.png" 
      class="flores-orilla flor-izquierda" 
      alt="" 
      aria-hidden="true" 
    />
    <img 
      src="@/assets/ssss.png" 
      class="flores-orilla flor-derecha" 
      alt="" 
      aria-hidden="true" 
    />

    <section class="itinerario-poster" ref="sectionRef">

      <h2 class="poster-title">Itinerary</h2>

      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>

    <div class="rasgado rasgado-bottom"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Welcome Cocktail & Violin Performance',
        hora: '6:00 PM',
        icono: require('@/assets/copa1.png')
      },
      {
        nombre: 'Quinceañera Entrance',
        hora: '7:00 PM',
        icono: require('@/assets/co.png')
      },
      {
        nombre: 'Quinceañera Presentation',
        hora: '7:30 PM',
        icono: require('@/assets/mon1.png')
      },
      {
        nombre: 'Dinner',
        hora: '8:00 PM',
        nota: 'Enjoy the party!',
        icono: require('@/assets/cena.png')
      },
      {
        nombre: 'Party',
        hora: '9:00 PM',
        nota: 'Let’s enjoy the party!',
        icono: require('@/assets/disc.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>
<style scoped>
.itinerario-poster {
  background: radial-gradient(
    circle at 50% 50%,
    #2c2b2c 0%,
    #262525 50%,
    #181717 100%
  );
  padding: 60px 20px 60px;
  text-align: center;
  position: relative;
}

/* Estilos para las flores en los laterales */
.flores-orilla {
  position: absolute;
  width: 160px;
  max-width: 35vw;
  height: auto;
  opacity: 0.75;
  pointer-events: none;
  z-index: 1;
}

.flor-izquierda {
  left: -20px;
  top: 0px;
}

.flor-derecha {
  right: -20px;
  bottom: 0px;
  transform: scaleX(-1);
}

.poster-title {
  font-family: 'british', serif;
  font-size: 34px;
  letter-spacing: 2px;
  color: #fffbfb;
  padding-left:10px;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
}

.poster-item {
  margin-bottom: 42px;
  position: relative;
  z-index: 2;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #ffffff;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: radial-gradient(
    circle at 50% 50%,
    #2c2b2c 0%,
    #262525 50%,
    #181717 100%
  );
  z-index: 5;
  pointer-events: none;
}

.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.evento-hora {
  display: block;
  color: #fff;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}

.evento-nota {
  display: block;
  font-size: 15px;
  opacity: 0.85;
  margin-top: 2px;
}
</style>